import { Box, Typography, Divider, Link } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { WelcomeToNewCalendarNotification } from '../components/WelcomeToNewCalendarNotification';
import { useCurrentuser } from '@uplift/contexts';
import { useIsCurrentProviderLive, useIsMobile } from '@uplift/hooks';
import { useState } from 'react';
import { Alert } from '@uplift/ui-v2';

export const TutorialBanner: React.VFC = () => {
  const [ showTutorial, setShowTutorial ] = useState(false);
  const me = useCurrentuser();
  const isProviderInLiveStatus = useIsCurrentProviderLive(me);
  const { classes } = useStyles();
  const isMobile = useIsMobile();

  const alertMessage = isMobile
    ? "This preview lets you add date overrides to your availability. Sessions will be available when you're live."
    : "This preview lets you make edits to your availability. Sessions will be available when you're live.";

  if (isProviderInLiveStatus) {
    return null;
  }

  return (
    <>
      <WelcomeToNewCalendarNotification showTutorial={showTutorial} setShowTutorial={setShowTutorial} />
      {
        !isProviderInLiveStatus && (
          <>
            <Alert severity="info" flat className={classes.onboardingAlert} showIcon={!isMobile}>
              <Box display="flex" alignItems="center">
                <Typography className={classes.alertTitle}>
                  {alertMessage}
                </Typography>
                {!isMobile && (
                  <Link
                    onClick={() => {
                      setShowTutorial(true);
                    }} style={{ marginLeft: '8px' }}
                  >
                    Watch Tutorial</Link>
                )}
              </Box>
            </Alert>
            <Divider />
          </>
        )
      }
    </>
  );
};

const useStyles = makeStyles()(() => ({
  onboardingAlert: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& a': {
      color: 'inherit',
      fontSize: '16px',
      textDecoration: 'underline',
      fontWeight: 400,
      '&:hover': {
        color: 'inherit',
        cursor: 'pointer',
      },
    }
  },
  alertTitle: {
    fontSize: '16px',
    fontWeight: 450,
    lineHeight: '24px',
    letterSpacing: '0.5px',
    textAlign: 'left',
  },
}));
